module.exports = __webpack_public_path__ + "static/media/wix.8fd391e1.svg";